module.exports = __webpack_public_path__ + "static/media/auth_gov_logo.a10ebfa3.svg";